import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { RegistrationModal } from './RegistrationModal';
export function HeroSection() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  return <>
      <section className="relative overflow-hidden bg-gradient-to-br from-[#E8F4F8] to-white pt-20 pb-32" data-id="element-74">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-75">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-76">
            {/* Left content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-77">
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6" data-id="element-78">
                <Sparkles className="w-4 h-4 text-[#F4A460]" data-id="element-79" />
                <span className="text-sm font-medium text-[#2C3E50]" data-id="element-80">
                  Gratuita para siempre
                </span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-[#2C3E50] mb-6 leading-tight" data-id="element-81">
                Emprende <span className="text-[#5B9BD5]" data-id="element-82">Fullpass</span>
              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-83">
                Tu tarjeta de fidelización que te conecta con beneficios
                exclusivos en el ecosistema emprendedor ecuatoriano.
              </p>

              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={() => setIsRegistrationOpen(true)} className="bg-[#5B9BD5] text-white px-8 py-4 rounded-lg font-semibold shadow-lg hover:bg-[#4A8AC4] transition-colors" data-id="element-84">
                Obtener mi tarjeta
              </motion.button>
            </motion.div>

            {/* Right content - Card visual */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative" data-id="element-85">
              <div className="relative" data-id="element-86">
                {/* Card mockup */}
                <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-8 shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-300" data-id="element-87">
                  <div className="flex justify-between items-start mb-12" data-id="element-88">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/63j4EpDSw13WgtsLuH2UBk/image.png" alt="Emprende Fullpass Logo" className="h-20 w-auto" data-id="element-89" />
                    <div className="text-gray-700 text-right" data-id="element-90">
                      <div className="text-sm opacity-70" data-id="element-91">Miembro desde</div>
                      <div className="font-semibold" data-id="element-92">2024</div>
                    </div>
                  </div>

                  <div className="space-y-4 mb-8" data-id="element-93">
                    <div className="text-gray-800" data-id="element-94">
                      <div className="text-sm opacity-70 mb-1" data-id="element-95">
                        Nombre del titular
                      </div>
                      <div className="text-xl font-semibold" data-id="element-96">
                        Juan Pérez Morales
                      </div>
                    </div>

                    <div className="text-gray-800" data-id="element-97">
                      <div className="text-sm opacity-70 mb-1" data-id="element-98">
                        Número de tarjeta
                      </div>
                      <div className="text-lg font-mono tracking-wider" data-id="element-99">
                        **** **** **** 1234
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between items-end" data-id="element-100">
                    <div className="text-gray-800" data-id="element-101">
                      <div className="text-2xl font-bold" data-id="element-102">Fullpass</div>
                      <div className="text-sm opacity-70" data-id="element-103">Emprende</div>
                    </div>
                    <div className="w-12 h-12 bg-white/40 rounded-lg backdrop-blur-sm border border-gray-300" data-id="element-104"></div>
                  </div>
                </div>

                {/* Floating elements */}
                <motion.div animate={{
                y: [0, -10, 0]
              }} transition={{
                duration: 3,
                repeat: Infinity
              }} className="absolute -top-4 -right-4 bg-[#F4A460] text-white px-4 py-2 rounded-full shadow-lg font-semibold text-sm" data-id="element-105">
                  100% Gratis
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <RegistrationModal isOpen={isRegistrationOpen} onClose={() => setIsRegistrationOpen(false)} data-id="element-106" />
    </>;
}